import { Vector2Tuple, Vector3 } from 'three';

import { NavMeshQuery } from '@recast-navigation/core';

import { isPointInNavMesh } from './isPointInNavMesh.js';

const _v = new Vector3();

export const isPolygonInNavMesh = (polygon: Vector2Tuple[], navMeshQuery?: NavMeshQuery) => {
  if (!navMeshQuery) {
    return true;
  }
  return polygon.every((position) =>
    isPointInNavMesh(_v.set(position[0], 0, position[1]), navMeshQuery)
  );
};
